import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { LabelL } from 'atoms/typography';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useIntlContext } from 'contexts/intl';
import { useSportContext } from 'contexts/sport';
import { useReferralProgramConfig } from 'hooks/useReferralProgramConfig';

import creditCard from './assets/credit-card.png';
import texture from './assets/referral-program-texture.svg';

const Root = styled.div`
  border-radius: var(--intermediate-unit);
  padding: var(--triple-unit);
  background:
    no-repeat url(${creditCard}) right center / contain padding-box,
    radial-gradient(
      25% 100% at 75% 50%,
      var(--c-rivals-purple-600),
      transparent
    ),
    linear-gradient(
        to bottom,
        rgba(var(--c-rgb-black), 0.3),
        rgba(var(--c-rgb-black), 0.9)
      )
      padding-box,
    repeat url(${texture}) center / cover padding-box,
    linear-gradient(
        to bottom,
        var(--c-rivals-purple-300),
        var(--c-rivals-purple-300)
      )
      padding-box,
    linear-gradient(
        to bottom,
        var(--c-rivals-purple-600),
        var(--c-rivals-purple-300)
      )
      border-box;

  border: 2px solid transparent;
`;
const StyledLabelL = styled(LabelL)`
  max-width: 50%;
`;

type Props = { referralUrl?: string };
export const ReferalProgramBlock = ({ referralUrl }: Props) => {
  const { sport } = useSportContext();
  const { fiatCurrency } = useCurrentUserContext();
  const { userFiatAmount } = useReferralProgramConfig(sport);
  const { formatNumber } = useIntlContext();

  const amount =
    userFiatAmount &&
    formatNumber(userFiatAmount, {
      style: 'currency',
      currency: fiatCurrency.code,
      maximumFractionDigits: 0,
    });

  return (
    <Root as={referralUrl ? Link : 'div'} to={referralUrl}>
      <StyledLabelL bold>
        <FormattedMessage
          id="ReferalProgramBlock.text"
          defaultMessage="Get {amount} for each referred friend!"
          values={{ amount }}
        />
      </StyledLabelL>
    </Root>
  );
};
